"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActionState = void 0;
class ActionState {
    constructor(id, sequence, actorId, args) {
        this.id = id;
        this.sequence = sequence;
        this.actorId = actorId;
        this.args = args;
    }
}
exports.ActionState = ActionState;
